import "./ProductCard.css";
import { Link } from "react-router-dom";

const ProductCard = ({ title, description, image, slug }) => {
  return (
    <Link to={`/product/${slug}`} className="product-card__link">
    <div className="product-card">
      <div className="product-card__image-container">
        <img
          className="product-card__image"
          src={image}
          alt={title}
          loading="lazy"
          onError={(e) => {
            e.target.style.opacity = "0.3";
          }}
        />
      </div>
      <div className="product-card__info">
        <h3 className="product-card__title">{title}</h3>
        <p className="product-card__description">{description}</p>
      </div>
    </div>
    </Link>
  );
};

export default ProductCard;
